// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		loadProductFirst: false,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style2'
	},
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

  console.log('Boost Inject')
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;

		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
      
      	var tags = data.tags;
      	var comingCheck = jQuery.inArray("coming-back", tags) != -1;
      	var previewCheck = jQuery.inArray("preview", tags) != -1;
      	
        if(previewCheck == true && data.available == false) {
          
           // Add preview soon Label
        	itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildPreviewLabel(data));
          
           // Other blank
        	itemHtml = itemHtml.replace(/{{itemComing}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSale}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemNew}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildOtherBlank());
          
        } else if(comingCheck == true && data.available == false) {
          
           // Add coming soon Label

          itemHtml = itemHtml.replace(/{{itemComing}}/g, buildComingLabel(data));
          
           // Other blank
          itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSale}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemNew}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildOtherBlank());
          
        } else if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
          // Add sold out Label
		  		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
          
          // Other blank
          itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemComing}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSale}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemNew}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildOtherBlank());
          
        }else if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
          // Add sale Label
          itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
          
          // Other blank
          itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemComing}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemNew}}/g, buildOtherBlank());
          itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildOtherBlank());
          
        }else if(jQuery.inArray("preorder", tags) != -1) {
        	// Add pre order Label
						itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildPreorderLabel(data));
          
          	// Other blank
						itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemComing}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemNew}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemSale}}/g, buildOtherBlank());
          
        } else {
        	// Add new Label
          	itemHtml = itemHtml.replace(/{{itemNew}}/g, buildNewLabel(data));
          
          	// Other blank
          	itemHtml = itemHtml.replace(/{{itemPreview}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemComing}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemPreorder}}/g, buildOtherBlank());
            itemHtml = itemHtml.replace(/{{itemSale}}/g, buildOtherBlank());
        }
      
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

        /* Swym integration */
        var itemWishlistHtml = '<button data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product wishlist swym-button product_' + data.id + '" data-swaction="addToWishlist" data-product-id="' + JSON.stringify(data.id) + '" data-variant-id="' + data.variants[0].id + '" data-product-url="' + boostPFSConfig.shop.url + Utils.buildProductItemUrl(data, false) + '"></button>';
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
      
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 1 / aspectRatio * 100;

			html += '<div';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>'
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + flipImageSrcSet + '" ' +
				'height="' + images[1].height + '" ' +
				'width="' + images[1].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			}
			html += '</div>';
			html += '</div>';
		} else {
				var placeholder = boostPFSConfig.general.no_image_url;
			html += '<div>';
			html += '<div class="media media--transparent media--adapt" style="padding-bottom: 125%;">'
      html += '<img src="' + placeholder + '" class="motion-reduce" alt="' + imgAlt + '" height="450" width="360">'
      html += '</div>';
			html += '</div>';
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt class="visually-hidden visually-hidden--inline">
								<span>
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare visually-hidden visually-hidden--inline">
								<span>
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<span class="price-item price-item--regular strike">
								${Utils.formatMoney(data.compare_at_price_min)}
								</span>
						  	</dd>
							<dt class="visually-hidden visually-hidden--inline">
							  <span>${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (soldOut) {
			//soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
			soldOutLabel = '<span class="badge color-so-badge" aria-hidden="true">Sold Out</span>';
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (onSale && !soldOut) {
			// saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
			saleLabel = '<span class="badge color-sale-badge" aria-hidden="true">Sale</span>';
		}
		return saleLabel;
	}
  
    function buildPreorderLabel(data){
		var preLabel = '';
        var tags = data.tags;
        if(jQuery.inArray("preorder", tags) != -1) {
         preLabel += '<span class="badge color-preorder-badge" aria-hidden="true">Pre-Order</span>';
        }
      
      return preLabel;
    }
  
    function buildOtherBlank(){
		var otherBlank = '';
      	return otherBlank;
    }
  
    function buildNewLabel(data) {
      // Build New label
      var newLabel = '';
//       var tags = data.tags;
//       if(jQuery.inArray("New", tags) != -1) {
//        newLabel += '<span class="badge badge--bottom-left color-accent-2 new__badge">New</span>';
//       }
      var date_published = new Date(data.published_at).getTime() / 1000;
      // var date_published_second = date_published.getSeconds()
      var date_now = new Date().getTime() / 1000;
      // var seconds_now = date_now.getSeconds();
      var date_difference = date_now - date_published; 

      if(date_difference < 2592000){
      	newLabel += '<span class="badge color-new-badge" aria-hidden="true" date-diff="' + date_difference + '">New</span>';		
      } 
      
      return newLabel;
    }
  
    function buildPreviewLabel(data) {
      // Build preview label
      var previewLabel = '';
      var tags = data.tags;
     // console.log(tags)
      if(jQuery.inArray("preview", tags) != -1) {
       previewLabel += '<span class="badge badge--bottom-left color-preview-badge">Coming Soon</span>';
      }
      return previewLabel;
    }

    function buildComingLabel(data) {
      // Build coming back label
      var comingLabel = '';
      var tags = data.tags;
     // console.log(tags)
      if(jQuery.inArray("coming-back", tags) != -1) {
       comingLabel += '<span class="badge badge--bottom-left color-cb-badge">Coming Back</span>';
      }
      return comingLabel;
    }

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '<li class="disable"><span class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd"d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"  fill="currentColor"></path></svg></span></li>';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisableHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
              	var sortingItemsDesk = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
                
					sortingItemsDesk += '<div data-value="' + k + '"' + isSelected + ' class="sorting-option">' + sortingArr[k] + '</div>';
                  	sortingItemsHtml += '<option value="' + k + '"' + isSelected + ' class="sorting-option">' + sortingArr[k] + '</option>';  
				}
                  var sortingDesk = '<div name="sort_by" class="collection-filters__sort desktop sort-desktop-only" id="SortBy" aria-describedby="a11y-refresh-page-message">{{sortingItemsDesk}}</div>';
                  var sortingMobile = '<select name="sort_by" class="select__select collection-filters__sort mobile sort-mobile-only" id="SortBy" aria-describedby="a11y-refresh-page-message">{{sortingItems}}</select><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';
                  var sortingHtml = sortingDesk + sortingMobile;
                  sortingHtml = sortingHtml.replace(/{{sortingItemsDesk}}/g, sortingItemsDesk);
              	  html = sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);          
			}
		}
		return html;
	};



	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
      
          jQ('.desktop .sorting-option').each(function()  {
             $(this).on("click", function(){
              FilterApi.setParam('sort', jQ(this).data('value'));
              FilterApi.setParam('page', 1);
               FilterApi.applyFilter('sort');
             });
          });
      
        jQ('.collection-filters__sort.mobile').change(function(e) {
              e.preventDefault();
              FilterApi.setParam('sort', jQ(this).val());
              FilterApi.setParam('page', 1);
              FilterApi.applyFilter('sort');
          });
        
	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      /** Start Swym integration **/
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function(swat) { 
        // Wrap with callback for loading without additional checks
        var products = [];
        data.forEach(function(product) {
          var image_src = Utils.getFeaturedImage(product.images_info);
          var productCopy = product;
          productCopy.featured_image = image_src;
          productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
          productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
          products.push(productCopy);
        });
        swat.mapShopifyProducts(products); // Product mapped data to swym layer
        swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
      });
      /** End Swym integration **/
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
      	if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
      	const urlParams = new URLSearchParams(window.location.search);
        const param_x = urlParams.getAll('pf_t_type');
      	const titleLength = $('.collection-hero__title .category-type').length;

        var FilterData = '';
       var length = param_x.length;
        if(param_x.length > 0){
          jQ(param_x).each(function(i, value) {
              console.log('each',i, value);
              if ( value != '' ) {
                  if(i === length-1) {  //The last one
                      FilterData += ' ' + value;
                  } else {
                      FilterData += ' ' + value + ',';
                  } 
              }   
          });
        }
     

      /*** MC UPDATE 2/3/25
      if(FilterData){
     
         if(titleLength == 0){
            $('.collection-hero__title').append('<span class="category-type">: '+FilterData+'</span>');
          }else{
            $('.collection-hero__title .category-type').text(':'+FilterData);
          }
        }else{
          $('.collection-hero__title .category-type').remove();	
        }
      	$('.collection-hero__title').show();
   ***/
      
      jQ('.boost-custom-filters-label').click(function(){
       	jQ('.boost-pfs-filter-tree').addClass('boost-pfs-filter-tree-mobile-open')
      })
	};

	/************************** END BUILD TOOLBAR **************************/
})();